import ConsentDocumentService from './consent-document.service';
import ProtocolNumberService from './protocol-number.service';
import SpecimenSourceService from './specimen-source.service';
import QuestionService from './question.service';
import FormTagService from './form-tag.service';
import FormService from './form.service';
import CaseService from './case.service';

export default {
  medicalRegistry: ({ axios }) => ({
    consentDocumentService: new ConsentDocumentService({ axios }),
    protocolNumberService: new ProtocolNumberService({ axios }),
    specimenSourceService: new SpecimenSourceService({ axios }),
    questionService: new QuestionService({ axios }),
    formTagService: new FormTagService({ axios }),
    formService: new FormService({ axios }),
    caseService: new CaseService({ axios }),
  }),
};
